/**
 * Header title de-duplication.
 *
 * A competition's brand name usually carries its season ("Champions League 26/27") and the
 * shell header renders that season again as its own badge next to the title. Showing both
 * reads as a bug, so the badge wins and the title drops the trailing season.
 */

/** Matches a trailing season the badge already shows: "26/27" or its "2026/27" long form. */
function seasonSuffixPattern(season: string): RegExp | null {
  const trimmed = season.trim();
  const short = /^(\d{2})\/(\d{2})$/.exec(trimmed);
  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const alternatives = short ? [`\\d{2}${escaped}`, escaped] : [escaped];
  return trimmed ? new RegExp(`\\s*(?:${alternatives.join('|')})$`) : null;
}

/**
 * Drops `season` off the end of `title` when the header shows it separately.
 * Returns `title` untouched when it does not end with that season, or when stripping
 * would leave nothing (a competition literally named after its season).
 */
export function competitionHeaderTitle(title: string, season?: string | null): string {
  if (!season) return title;
  const pattern = seasonSuffixPattern(season);
  if (!pattern) return title;
  const stripped = title.replace(pattern, '').trim();
  return stripped || title;
}
